import type { SurveyAction } from '../../api/workEnvironmentTypes';

export type { SurveyAction };

export const ALL_SURVEY_ACTIONS: SurveyAction[] = [
  'assess',
  'addData',
  'advance',
  'propose',
  'hideProposal',
  'makePlan',
  'reviewPlan',
  'followUp',
  'share',
  'startEvaluation',
  'decideResidual',
  'requestSignature',
  'archive',
];

/**
 * The actions the viewer may take. A survey from a backend that does not send them yet keeps
 * every action, as before, so nothing disappears while the two are deployed.
 */
export const allowedActions = (
  actions: SurveyAction[] | undefined,
): ReadonlySet<SurveyAction> => new Set(actions ?? ALL_SURVEY_ACTIONS);

export const mayTake = (
  allowed: ReadonlySet<SurveyAction>,
  action: SurveyAction,
) => allowed.has(action);
